import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetUrl } from "../config/GetUrl";

export const ProductApi = createApi({
    reducerPath: "ProductApi",
    baseQuery: fetchBaseQuery({
        baseUrl: GetUrl.API_URL,
    }),
    endpoints: (builder) => ({
        CreateProductPost: builder.mutation({
            query: (data) => ({
                url: "/api/v1/Admin/createProduct",
                method: "POST",
                body: data,
                headers: {
                    authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
                },
            }),
        }),
        GetProduct: builder.query({
            query: ({ page = 1, limit = 20, search = "", categoryId = "" }) => ({
                url: `/api/v1/User/get-all-products?page=${page}&limit=${limit}&search=${encodeURIComponent(search || "")}&categoryId=${encodeURIComponent(categoryId || "")}`,
                method: "GET",
                headers: {
                    authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
                },
            }),
        
    transformResponse: (response) => {
  /* GALAXY_GETPRODUCT_NORMALIZED_V4 */
  const payload =
    response?.data?.data ??
    response?.data ??
    response ??
    {};

  const rawProducts =
    Array.isArray(payload)
      ? payload
      : (
          payload?.products ??
          response?.products ??
          response?.data?.products ??
          response?.data?.data?.products ??
          []
        );

  const products =
    Array.isArray(rawProducts)
      ? rawProducts
      : [];

  const pagination =
    payload?.pagination ??
    response?.pagination ??
    response?.data?.pagination ??
    response?.data?.data?.pagination ??
    {};

  /*
    ManageProduct.jsx uses productData as an array.
    Extra properties preserve compatibility with any
    older code that expects .products/.data/.pagination.
  */
  return Object.assign(
    [...products],
    {
      products,
      pagination,

      data: {
        products,
        pagination
      }
    }
  );
}
  }),

        GetSingleProduct: builder.query({
            query: (id) => ({
                url: `/api/v1/Admin/getProductDetail/${id}`,
                method: "GET",
                headers: {
                    authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
                },
            }),
        }),
        EditProduct: builder.mutation({
            query: ( {productId,formData }) => ({
                url: `/api/v1/Admin/updateProduct/${productId}`,
                method: "POST",
                body: formData,
                headers: {
                    authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
                },
            }),
        }),
        DeleteProduct: builder.mutation({
            query: (id) => ({
                url: `/api/v1/Admin/deleteProduct/${id}`,
                method: "DELETE",
                headers: {
                    authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
                },
            }),
        }),
    }),
});

export const {
    useCreateProductPostMutation,
    useGetProductQuery,
    useGetSingleProductQuery,
    useEditProductMutation,
    useDeleteProductMutation,
} = ProductApi;

